import React, { useState, createContext, useContext } from 'react'
import { API } from 'logic'

const ExampleContext = createContext<any>(null)

export const ExampleDataProvider = ({ children }: { children: React.ReactNode }) => {
	const [loading, setLoading] = useState(true)
	const [data, setData] = useState({})

	const fetchExampleData = async () => {
		setLoading(true)
		const { data: exampleData, errors } = await API.fetchModel(1, 'demo', 'asc')

		if (exampleData) {
			setData(exampleData)
		}

		setLoading(false)
		return { data: exampleData, errors }
	}

	const updateExampleData = () => {
		setData({
			title: 'New title',
			body: 'New body',
		})
	}

	return (
		<ExampleContext.Provider value={{ loading, data, fetchExampleData, updateExampleData }}>
			{children}
		</ExampleContext.Provider>
	)
}

export const withExampleData = (Component: React.ComponentType<any>) => {
	return (props: any) => {
		const exampleData = useContext(ExampleContext)

		return <Component {...props} {...exampleData} />
	}
}
